/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Vendor Requires
require('./vendor/slick.min.js');
require('./vendor/collapse');
require('./vendor/dropdown');
require('./vendor/modal');
require('./vendor/picturefill');
// require('./vendor/tab');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');

//bootstrap components
//require('bootstrap/js/src/tab');

// App Requires
//require('./app/hero');
require('./app/sliders');
require('./app/primary-navigation');
require('./app/sticky-nav');



// WEBPACK FOOTER //
// ./js/src/app.js